import React, { useState } from 'react';
import { ADD_NOTE_OPTIONS } from '../../common/constant/common-constants';
import { DOCTOR_NOTES_UI_FIELDS, NOTE_INPUT_TYPE, NOTE_YES_NO } from '../../common/constant/notes-contants';
import CustomSelect from '../CustomSelect/CustomSelect';
import './InitialAssessmentNote.scss'

function InitialAssessmentNote(props) {

    console.log("add note active", props.addNoteActive);
    return (
        <div className="template-input-container">
            <div className="header-add-notes">
                <span className="heading-template">{ADD_NOTE_OPTIONS.INITIAL_ASSESSMENT}</span>
                {props.addNoteActive && <div className="template-add-note-save">
                    <div className="template-common-btn cancel" onClick={props.handleNoteCancel}>Cancel</div>
                    <div className="template-common-btn save" onClick={props.handleNoteSave}>Save</div>
                </div>}
            </div>
            <div className="patient-details-note">
                <div className="name-age-gender-note">
                    <div className="patient-name-note">
                        <div className="note-label">Name</div>
                        <input
                            id="patient-name"
                            className="pd-input"
                            placeholder="Name"
                            readOnly={true}
                            value={props.patientData && props.patientData.name ? props.patientData.name : ""}
                        />
                    </div>
                    <div className="patient-age-note">
                        <div className="note-label">Age</div>
                        <input
                            id="patient-age"
                            className="pd-input"
                            placeholder="Age"
                            value={props.patientData && props.patientData.age ? props.patientData.age : ""}
                        />
                    </div>
                    <div className="patient-gender-note">
                        <div className="note-label">Gender</div>
                        <div className="pat-detail-gender-radio">
                            <div className="gender-radio-option">
                                <input
                                    type='radio'
                                    id="patient-male"
                                    name="gender-note"
                                    defaultChecked={props.patientData && props.patientData.gender === 'M' ? true : false}
                                />
                                <label htmlFor="patient-male">M</label>
                            </div>
                            <div className="gender-radio-option">
                                <input
                                    type='radio'
                                    id="patient-female"
                                    name="gender-note"
                                    defaultChecked={props.patientData && props.patientData.gender === 'F' ? true : false}
                                />
                                <label htmlFor="patient-female">F</label>
                            </div>
                            <div className="gender-radio-option">
                                <input
                                    type='radio'
                                    id="patient-other"
                                    name="gender-note"
                                    defaultChecked={props.patientData && props.patientData.gender === 'Other' ? true : false}
                                />
                                <label htmlFor="patient-other">Other</label>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="height-wt-bmi-bg-note">
                    <div className="patient-height-note pat-detail">
                        <div className="note-label">Height</div>
                        <input
                            id="patient-height"
                            className="pd-input"
                            placeholder="Height"
                            value={props.patientData && props.patientData.height ? props.patientData.height : ""}
                        />
                    </div>
                    <div className="patient-weight-note pat-detail">
                        <div className="note-label">Weight</div>
                        <input
                            id="patient-weight"
                            className="pd-input"
                            placeholder="Weight"
                            value={props.patientData && props.patientData.weight ? props.patientData.weight : ""}
                        />
                    </div>
                    <div className="patient-bmi-note pat-detail">
                        <div className="note-label">BMI</div>
                        <input
                            id="patient-bmi"
                            className="pd-input"
                            placeholder="BMI"
                            value={props.patientData &&
                                props.patientData.height &&
                                props.patientData.weight ? ((props.patientData.weight / (props.patientData.height * props.patientData.height)) * 10000).toFixed(2) : ""}
                        />
                    </div>
                    <div className="patient-bg-note pat-detail">
                        <div className="note-label">Blood Group</div>
                        <input
                            id="patient-bg"
                            className="pd-input"
                            placeholder=""
                            value={props.patientData && props.patientData.bloodGroup ? props.patientData.bloodGroup : ""}
                        />
                    </div>
                </div>
            </div>
            <div className="doctor-notes-fields">
                {
                    DOCTOR_NOTES_UI_FIELDS.map((parField) => {
                        return (
                            <div className={`parent-field`} id={parField.id}>
                                <div className="parent-topic">{parField.parentFieldLabel}</div>
                                <div className={`child-fields ${parField.flexDir ? parField.flexDir : ''} ${parField.childGap ? parField.childGap : ''} ${parField.display ? parField.display : ''} ${parField.templateCol ? parField.templateCol : ''}`}>
                                    {parField.childField.map((child) => {
                                        if (child.type === NOTE_INPUT_TYPE.RADIO) {
                                            // console.log("child name", child.name, "par name", parField.name);
                                            return (
                                                <div className={`child-radio ${child.childDisplay ? child.childDisplay : ""} ${child.childFlexDir ? child.childFlexDir : ""}`} id={child.id}>
                                                    {child.img && <img src={child.img} className='child-emoji' />}
                                                    <input
                                                        type='radio'
                                                        name={child.commonRadioName}
                                                        value={''}
                                                        readOnly={child.readOnly}
                                                        checked={props.activeNote && props.activeNote[parField.name] === child.name}
                                                        onChange={(event) => props.handleTemplateInputChange(child.name, child.type, event && event.target && event.target.value, parField.name)}
                                                    />
                                                    {child.hurtScore && <span className="hurt-score">{child.hurtScore}</span>}
                                                    <label className="child-radio-label">{child.label}</label>
                                                    {
                                                        ((props.templateInputObj &&
                                                            props.templateInputObj[parField.name] &&
                                                            props.templateInputObj[parField.name].childSelected &&
                                                            (props.templateInputObj[parField.name].childSelected.split('_')[1] === NOTE_YES_NO.YES || props.templateInputObj[parField.name].childSelected.split('_')[1] === NOTE_YES_NO.ABNORMAL) &&
                                                            (child.name.split('_')[1] === NOTE_YES_NO.YES || child.name.split('_')[1] === NOTE_YES_NO.ABNORMAL)) ||
                                                            ((props.activeNote &&
                                                                props.activeNote[parField.name] === child.name &&
                                                                (props.activeNote[parField.name].split('_')[1] === NOTE_YES_NO.YES || props.activeNote[parField.name].split('_')[1] === NOTE_YES_NO.ABNORMAL)))
                                                        ) && (parField.semanticTag ?
                                                            <CustomSelect
                                                                handleChange={(event) => props.handleTemplateInputChange(child.name, NOTE_INPUT_TYPE.SELECT_DETAIL, event, parField.name)}
                                                                // label='DRUG NAME'
                                                                value={props.activeNote &&
                                                                    props.activeNote[parField.name] &&
                                                                    props.activeNote[(props.activeNote[parField.name].split('_')[0] + "Detail")] ?
                                                                    {
                                                                        name: props.activeNote[(props.activeNote[parField.name].split('_')[0] + "Detail")],
                                                                        label: props.activeNote[(props.activeNote[parField.name].split('_')[0] + "Detail")]
                                                                    } :
                                                                    {
                                                                        name: props.templateInputObj && props.templateInputObj[parField.name] && props.templateInputObj[parField.name].details,
                                                                        label: props.templateInputObj && props.templateInputObj[parField.name] && props.templateInputObj[parField.name].details
                                                                    }
                                                                }
                                                                onInputChange={(event) => {
                                                                    props.handleSelectInput(event, parField.semanticTag || child.semanticTag);
                                                                    props.handleCurrentSelectBox(child.name);
                                                                }}
                                                                options={props.selectOptionsAvailable || child.options}
                                                                placeholder={``}
                                                                backgroundColor='#1F1F1F'
                                                                components={{
                                                                    IndicatorSeparator: () => null
                                                                }}
                                                                className='detail-select'
                                                                baseFontSize='15px'
                                                                isDisabled={!props.addNoteActive}
                                                                containerHeight='72%'
                                                            /> :
                                                            <input
                                                                className="details-on-yes pd-input"
                                                                type='text'
                                                                placeholder='Details'
                                                                value={props.activeNote &&
                                                                    props.activeNote[parField.name] &&
                                                                    props.activeNote[(props.activeNote[parField.name].split('_')[0] + "Detail")]}
                                                                onChange={(event) => props.handleTemplateInputChange(child.name, NOTE_INPUT_TYPE.DETAILS, event && event.target && event.target.value, parField.name)}
                                                            />)
                                                    }
                                                </div>
                                            )
                                        } else if (child.type === NOTE_INPUT_TYPE.SELECT) {
                                            return (
                                                <div className="child-topic-field" id={child.id}>
                                                    <label className="child-select-label">{child.label}</label>
                                                    <CustomSelect
                                                        // id="drug-name"
                                                        handleChange={(event) => props.handleTemplateInputChange(child.name, child.type, event)}
                                                        // label='DRUG NAME'
                                                        value={props.activeNote && props.activeNote[child.name] ?
                                                            { name: props.activeNote[child.name], label: props.activeNote[child.name] } :
                                                            {
                                                                name: props.templateInputObj && props.templateInputObj[child.name] && props.templateInputObj[child.name].name,
                                                                label: props.templateInputObj && props.templateInputObj[child.name] && props.templateInputObj[child.name].label
                                                            }}
                                                        onInputChange={(event) => {
                                                            props.handleSelectInput(event, parField.semanticTag || child.semanticTag);
                                                            props.handleCurrentSelectBox(child.name);
                                                        }}
                                                        options={props.selectOptionsAvailable && props.selectOptionsAvailable.length ? props.selectOptionsAvailable : child.options}
                                                        placeholder={``}
                                                        backgroundColor='#1F1F1F'
                                                        components={{
                                                            IndicatorSeparator: () => null
                                                        }}
                                                        isDisabled={!props.addNoteActive}
                                                        baseFontSize='15px'
                                                    />
                                                </div>
                                            )
                                        } else if (child.type === NOTE_INPUT_TYPE.TEXTAREA) {
                                            return (
                                                <div className="child-topic-field" id={child.id}>
                                                    <label className="child-textarea-label">{child.label}</label>
                                                    <textarea
                                                        // placeholder={child.label}
                                                        value={(props.activeNote && props.activeNote[child.name]) ? props.activeNote[child.name] : (props.templateInputObj && props.templateInputObj[child.name] && props.templateInputObj[child.name].value)}
                                                        className='textarea-input-note'
                                                        rows='5'
                                                        onChange={(event) => props.handleTemplateInputChange(child.name, child.type, event && event.target && event.target.value)}
                                                    />
                                                </div>
                                            )
                                        } else if (child.type === NOTE_INPUT_TYPE.INPUT) {
                                            return (
                                                <div className="child-topic-field" id={child.id}>
                                                    {!child.readOnly ? <label className="child-input-label">{child.label}</label> : ""}
                                                    {/* <label className="child-radio-label">{child.name}</label> */}
                                                    <input
                                                        type="text"
                                                        className={`pd-input ${child.readOnly ? 'read-only' : ''}`}
                                                        placeholder={child.readOnly ? child.label : ''}
                                                        readOnly={child.readOnly}
                                                        onChange={(event) => props.handleTemplateInputChange(child.name, child.type, event.target.value)}
                                                        value={(props.activeNote && props.activeNote[child.name]) ? props.activeNote[child.name] : (props.templateInputObj && props.templateInputObj[child.name] && props.templateInputObj[child.name].value)}
                                                    />
                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default InitialAssessmentNote;